import React, { useState, useEffect } from 'react';
import CurrencyInput from "react-currency-input-field";
import DateTimePicker, { dateTimeHelpers } from '../../../../components/utils/datetimepicker';
import Swal from 'sweetalert2';
import api from '../../../../config/axios';

import { FaRegSave, FaTimes } from 'react-icons/fa';

const AbrirCaixaModal = ({ onClose, onCaixaAtualizado }) => {
    const [formData, setFormData] = useState({
        valor: '',
        valor_cheque: '',
        data_hora_abertura: new Date(),
        maquina_id: '',
        numero_serial: '',
        conta_bancaria_id: ''
    });
    const [maquinasList, setMaquinasList] = useState([]);
    const [contasBancarias, setContasBancarias] = useState([]);

    useEffect(() => {
        fetchMaquinas();
        fetchContasBancarias();
    }, []);

    const fetchMaquinas = async () => {
        try {
            Swal.fire({
                title: "Carregando...",
                allowOutsideClick: false,
                allowEscapeKey: false,
                showConfirmButton: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });

            const response = await api.get('/maquinas-pagamento?page=1&limit=200&status=ativo');
            setMaquinasList(response.data.records || []);
            Swal.close();
        } catch (error) {
            Swal.close();
        }
    };

    const fetchContasBancarias = async () => {
        try {
            const response = await api.get('/contas-bancarias/para-lancamentos');
            setContasBancarias(response.data || []);
        } catch (error) {
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        
        setFormData((prevState) => ({
            ...prevState,
            [name]: value,
        }));

        if (name === 'maquina_id') {
            const maquinaSelecionada = maquinasList.find(maq => maq.id.toString() === value);
            if (maquinaSelecionada) {
                setFormData(prevState => ({
                    ...prevState,
                    numero_serial: maquinaSelecionada.serial || ''
                }));
            }
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.maquina_id) {
            Swal.fire('Erro', 'O campo Máquina de Pagamento é obrigatório', 'error');
            return;
        }

        const dataHoraFormatada = dateTimeHelpers.dateTimeToString(formData.data_hora_abertura);

        const data = {
            valor_inicial_dinheiro: formData.valor || 0,
            valor_inicial_cheque: formData.valor_cheque || 0,
            created_at: dataHoraFormatada,
            maquina_id: formData.maquina_id,
            conta_bancaria_id: formData.conta_bancaria_id || null
        }

        Swal.fire({
            title: "Carregando...",
            allowOutsideClick: false,
            allowEscapeKey: false,
            showConfirmButton: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        try {
            await api.post(`/caixas/abrir`, data);

            onCaixaAtualizado();
            onClose();
            Swal.fire('Sucesso', 'Caixa aberto com sucesso!', 'success');
        }
        catch (error) {
            Swal.fire('Erro', `Erro ao salvar: ${error.response.data.message}`, 'error');
        }
    };

    return (
        <div className="modal fade show" tabIndex="-1" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <div className="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered">
                <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                    <div className="modal-header">
                        <h4 className="fw-bold mt-2">Novo Caixa</h4>
                        <button type="button" className="btn-close" onClick={onClose} aria-label="Close"></button>
                    </div>

                    <div className="modal-body">
                        <form onSubmit={handleSubmit}>
                            <div className="row mt-3">
                                <div className="col-lg-4 col-12">
                                    <label className="form-label fw-bold">Valor</label>
                                    <CurrencyInput
                                        name="valor"
                                        placeholder="R$ 0,00"
                                        value={formData.valor}
                                        decimalsLimit={2}
                                        decimalSeparator=","
                                        groupSeparator="."
                                        prefix="R$ "
                                        className="form-control"
                                        autoComplete="off"
                                        onValueChange={(value) =>
                                            setFormData((prevState) => ({
                                                ...prevState,
                                                valor: value,
                                            }))
                                        }
                                    />
                                </div>
                                <div className="col-lg-4 col-12 mt-lg-0 mt-3">
                                    <label className="form-label fw-bold">Valor em Cheque</label>
                                    <CurrencyInput
                                        name="valor_cheque"
                                        placeholder="R$ 0,00"
                                        value={formData.valor_cheque}
                                        decimalsLimit={2}
                                        decimalSeparator=","
                                        groupSeparator="."
                                        prefix="R$ "
                                        className="form-control"
                                        autoComplete="off"
                                        onValueChange={(value) =>
                                            setFormData((prevState) => ({
                                                ...prevState,
                                                valor_cheque: value,
                                            }))
                                        }
                                    />
                                </div>
                                <div className="col-lg-4 col-12 mt-lg-0 mt-3">
                                    <label className="form-label fw-bold">Data e Hora de Abertura</label>
                                    <DateTimePicker
                                        selected={formData.data_hora_abertura}
                                        onChange={(date) => setFormData(prev => ({ ...prev, data_hora_abertura: date }))}
                                        className="form-control"
                                    />
                                </div>
                            </div>
                            <div className="row mt-3">
                                <div className="col-lg-4 col-12">
                                    <label className="form-label fw-bold">Máquina de Pagamento</label>
                                    <select
                                        className="form-select"
                                        name="maquina_id"
                                        value={formData.maquina_id}
                                        onChange={handleChange}
                                    >
                                        <option value="" hidden>Selecione...</option>
                                        {maquinasList.map(maquina => (
                                            <option key={maquina.id} value={maquina.id}>
                                                {maquina.apelido}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-lg-4 col-12 mt-lg-0 mt-3">
                                    <label className="form-label fw-bold">Número Serial</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="numero_serial"
                                        value={formData.numero_serial}
                                        disabled
                                    />
                                </div>
                                <div className="col-lg-4 col-12 mt-lg-0 mt-3">
                                    <label className="form-label fw-bold">Conta Bancária</label>
                                    <select
                                        className="form-select"
                                        name="conta_bancaria_id"
                                        value={formData.conta_bancaria_id}
                                        onChange={handleChange}
                                    >
                                        <option value="">Selecione...</option>
                                        {contasBancarias.map(conta => (
                                            <option key={conta.id} value={conta.id}>
                                                {conta.nome_exibicao || conta.nome}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div className="modal-footer mt-4">
                        <div className="row">
                            <div className="col-12 text-end">
                                <button className="btn btn-outline-danger" type="button" onClick={onClose}>
                                    <FaTimes /> Fechar
                                </button>
                                <button className="btn btn-custom-primary ms-3" type="submit" onClick={handleSubmit}>
                                    <FaRegSave /> Salvar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    );
};

export default AbrirCaixaModal;
